/* tslint:disable */
/* eslint-disable */
/**
 * Vocabulary Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Notation
 */
export interface Notation  {
    /**
     * 
     * @type {string}
     * @memberof Notation
     */
    notation?: string;
    /**
     * 
     * @type {string}
     * @memberof Notation
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof Notation
     */
    logo?: string;
}

/**
 * Check if a given object implements the Notation interface.
 */
export function instanceOfNotation(value: object): value is Notation {
    return true;
}

export function NotationFromJSON(json: any): Notation {
    return NotationFromJSONTyped(json, false);
}

export function NotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notation {
    if (json == null) {
        return json;
    }
    return {
        
                  'notation': json['notation'] == null ? undefined : json['notation'],
                  'label': json['label'] == null ? undefined : json['label'],
                  'logo': json['logo'] == null ? undefined : json['logo'],
    };
}

export function NotationToJSON(json: any): Notation {
    return NotationToJSONTyped(json, false);
}

export function NotationToJSONTyped(value?: Notation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'notation': value['notation'],
        'label': value['label'],
        'logo': value['logo'],
    };
}


